exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".todo-onboarding-wrapper {\n  height: 100%;\n}\n\n.todo-onboarding-wrapper .navigation-content-wrap {\n  display: flex;\n  flex-direction: column;\n}\n\n", ""]);

// exports
